import script from "./TournamentRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./TournamentRegistration.vue?vue&type=script&setup=true&lang=js"

import "./TournamentRegistration.vue?vue&type=style&index=0&id=c85baa2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c85baa2e"]])

export default __exports__